var map = {
	"./CM_DRAGON.png": "6f69",
	"./CM_MARSHMALLOW.png": "d9dd",
	"./CM_ROASTED.png": "c8b6",
	"./RBS_event_01.png": "24f2",
	"./RBS_event_01_loading.png": "4913",
	"./RBS_event_02.png": "8598",
	"./RBS_event_02_loading.png": "1f0e",
	"./RBS_event_03.jpg": "0542",
	"./RBS_event_03_loading.jpg": "18de",
	"./RBS_retailers.png": "a893",
	"./STORE_nanabozho.png": "2eb8",
	"./TBWTTNL_product_thumbnail.png": "abc7",
	"./TFT_app-icon-rounded.jpg": "fbbc",
	"./TFT_product_thumbnail.png": "1c9c",
	"./activity-sheet_thumbnail_mouse.jpg": "596d",
	"./activity-sheet_thumbnail_raccoon.jpg": "5db3",
	"./cards/1-start_v8e_front.png": "d137",
	"./cards/1-start_v8e_front_loading.jpg": "2852",
	"./cards/10-top-mountain_v8e.png": "3200",
	"./cards/10-top-mountain_v8e_loading.jpg": "c33d",
	"./cards/11-lake-and-cry_v8e.png": "00e3",
	"./cards/11-lake-and-cry_v8e_loading.jpg": "b5bb",
	"./cards/12-down-the-mtn_v8e.png": "621f",
	"./cards/12-down-the-mtn_v8e_loading.jpg": "0522",
	"./cards/13-end_v8e.png": "d05e",
	"./cards/13-end_v8e_loading.jpg": "1676",
	"./cards/2-lonely-bear_v8e.png": "482c",
	"./cards/2-lonely-bear_v8e_loading.jpg": "9d59",
	"./cards/3-longing-nl_v8e.png": "018b",
	"./cards/3-longing-nl_v8e_loading.jpg": "2977",
	"./cards/4-penguin-helper_v8e.png": "386b",
	"./cards/4-penguin-helper_v8e_loading.jpg": "2190",
	"./cards/4-shaman-helper_v8e.png": "d180",
	"./cards/4-shaman-helper_v8e_loading.jpg": "59b5",
	"./cards/5-leaving-home_v8e.png": "269e",
	"./cards/5-leaving-home_v8e_loading.jpg": "0a4f",
	"./cards/6-fox_v8e.png": "1b22",
	"./cards/6-fox_v8e_loading.jpg": "7046",
	"./cards/6-narwhal_v8e.png": "a27f",
	"./cards/6-narwhal_v8e_loading.jpg": "a164",
	"./cards/7-whale_v8e.png": "1b7f",
	"./cards/7-whale_v8e_loading.jpg": "9670",
	"./cards/8-reach-mountain_v8e.png": "fd1f",
	"./cards/8-reach-mountain_v8e_loading.jpg": "4a76",
	"./cards/9-climb_v8e.png": "a1ae",
	"./cards/9-climb_v8e_loading.jpg": "935f",
	"./cards/9-tunnel_v8e.png": "eb3d",
	"./cards/9-tunnel_v8e_loading.jpg": "1e0a",
	"./colored-test.png": "eb9c",
	"./cross-media.png": "932a",
	"./event_thumbnail.jpg": "1429",
	"./filters_is.png": "d172",
	"./header-video.mp4": "35d5",
	"./header_text_horizontal.png": "571e",
	"./hero_shelves.jpg": "e440",
	"./hero_shelves.png": "14d5",
	"./hero_shelves_summer-sale.png": "9e01",
	"./icon-close.png": "95d9",
	"./icon-close.svg": "ffed",
	"./icon-menu_blue.png": "de36",
	"./icon-menu_blue.svg": "b5f2",
	"./icon-menu_teal.png": "92c3",
	"./icon-menu_teal.svg": "f38a",
	"./icon_1.png": "86e8",
	"./icon_2.png": "5ff1",
	"./icon_3.png": "e91d",
	"./icon_arrow.png": "f997",
	"./icon_book.svg": "de53",
	"./icon_browse.png": "4705",
	"./icon_cross-media.png": "fb63",
	"./icon_footer.png": "8f30",
	"./icon_highlights.png": "a9d6",
	"./icon_link.png": "b8d0",
	"./icon_newsletter.png": "7731",
	"./icon_pin.svg": "83ff",
	"./icon_reviews.svg": "c51a",
	"./icon_try-home.png": "18aa",
	"./landing-pages/ICON_app-click.png": "f4b1",
	"./landing-pages/ICON_app-click_green.png": "ac58",
	"./landing-pages/hidden/h_app-icon.png": "ab99",
	"./landing-pages/hidden/h_header-1.png": "76e8",
	"./landing-pages/hidden/h_header-2.png": "0524",
	"./landing-pages/hidden/h_hidden-eyes.png": "d712",
	"./landing-pages/hidden/h_icon_arrow_red.png": "9b81",
	"./landing-pages/hidden/h_icon_artists.png": "1b11",
	"./landing-pages/hidden/h_icon_interact.png": "fa69",
	"./landing-pages/hidden/h_icon_interaction_red.png": "6d70",
	"./landing-pages/hidden/h_icon_postcard.png": "1e3e",
	"./landing-pages/hidden/h_icon_scan.png": "80b2",
	"./landing-pages/hidden/h_icon_watch.png": "7362",
	"./landing-pages/hidden/h_icon_watch_red.png": "3776",
	"./landing-pages/hidden/h_logo.png": "d23d",
	"./landing-pages/hidden/h_postcard-back.png": "5934",
	"./landing-pages/hidden/h_s1e1_gallery_1.png": "4875",
	"./landing-pages/hidden/h_s1e1_gallery_2.png": "5f85",
	"./landing-pages/hidden/h_s1e1_gallery_3.png": "f8a1",
	"./landing-pages/hidden/h_s1e1_interactions_1.png": "d5c5",
	"./landing-pages/hidden/h_s1e1_interactions_2.png": "42a4",
	"./landing-pages/hidden/h_s1e1_interactions_3.png": "0667",
	"./landing-pages/hidden/h_s1e1_thumbnail.png": "4153",
	"./landing-pages/hidden/h_s1e2_gallery_1.png": "1aea",
	"./landing-pages/hidden/h_s1e2_gallery_2.png": "a95f",
	"./landing-pages/hidden/h_s1e2_gallery_3.png": "6488",
	"./landing-pages/hidden/h_s1e2_gallery_4.png": "a428",
	"./landing-pages/hidden/h_s1e2_gallery_5.png": "c3be",
	"./landing-pages/hidden/h_s1e2_interactions_1.png": "b62b",
	"./landing-pages/hidden/h_s1e2_interactions_2.png": "f174",
	"./landing-pages/hidden/h_s1e2_thumbnail.png": "616e",
	"./landing-pages/hidden/h_s2e1_gallery_1.png": "03c9",
	"./landing-pages/hidden/h_s2e1_gallery_2.png": "f86c",
	"./landing-pages/hidden/h_s2e1_gallery_3.png": "b662",
	"./landing-pages/hidden/h_s2e1_gallery_4.png": "4cfe",
	"./landing-pages/hidden/h_s2e1_interactions_1.png": "73a9",
	"./landing-pages/hidden/h_s2e1_thumbnail.png": "55e4",
	"./landing-pages/hidden/h_s2e2_gallery_1.png": "b8fb",
	"./landing-pages/hidden/h_s2e2_gallery_2.png": "bbf4",
	"./landing-pages/hidden/h_s2e2_interactions_1.png": "2db2",
	"./landing-pages/hidden/h_s2e2_thumbnail.png": "bcd6",
	"./landing-pages/hidden/h_thumbnail.png": "58a6",
	"./landing-pages/hidden/h_tutorial_step-1.png": "1aa9",
	"./landing-pages/hidden/h_tutorial_step-2.png": "c3f8",
	"./landing-pages/hidden/h_tutorial_step-3.png": "6f0d",
	"./landing-pages/newsletter/background.png": "889d",
	"./landing-pages/newsletter/girl.png": "487a",
	"./landing-pages/tbwttnl/ICON_AGE_TBWTTNL.png": "d399",
	"./landing-pages/tbwttnl/ICON_AR.png": "19df",
	"./landing-pages/tbwttnl/ICON_CANADA.png": "f381",
	"./landing-pages/tbwttnl/ICON_VARIATIONS.png": "d2ec",
	"./landing-pages/tbwttnl/TBWTTNL_about-the-story.png": "2998",
	"./landing-pages/tbwttnl/TBWTTNL_app_feather.jpg": "00fa",
	"./landing-pages/tbwttnl/TBWTTNL_app_feather_loading.jpg": "abc6",
	"./landing-pages/tbwttnl/TBWTTNL_benefits_age.png": "f835",
	"./landing-pages/tbwttnl/TBWTTNL_benefits_canada.png": "7b59",
	"./landing-pages/tbwttnl/TBWTTNL_benefits_screentime.png": "9e75",
	"./landing-pages/tbwttnl/TBWTTNL_benefits_variations.png": "24ae",
	"./landing-pages/tbwttnl/TBWTTNL_cards-fit.jpg": "6305",
	"./landing-pages/tbwttnl/TBWTTNL_cards-fit_loading.jpg": "c384",
	"./landing-pages/tbwttnl/TBWTTNL_choice.jpg": "b0f1",
	"./landing-pages/tbwttnl/TBWTTNL_choice_loading.jpg": "c628",
	"./landing-pages/tbwttnl/TBWTTNL_fit-puzzle.jpg": "2732",
	"./landing-pages/tbwttnl/TBWTTNL_fit-puzzle_loading.jpg": "ee36",
	"./landing-pages/tbwttnl/TBWTTNL_hero.png": "11be",
	"./landing-pages/tbwttnl/TBWTTNL_info-mobile.png": "c87c",
	"./landing-pages/tbwttnl/TBWTTNL_info.png": "5de5",
	"./landing-pages/tbwttnl/TBWTTNL_render_special-cards.png": "b44b",
	"./landing-pages/tbwttnl/TBWTTNL_scribble_items.png": "df61",
	"./landing-pages/tbwttnl/TBWTTNL_story.jpg": "42ca",
	"./landing-pages/tbwttnl/TBWTTNL_thumbnail.jpg": "f30b",
	"./landing-pages/tosola/BOX_book.png": "9df3",
	"./landing-pages/tosola/BOX_characters.png": "9ea6",
	"./landing-pages/tosola/BOX_clues.png": "7bdd",
	"./landing-pages/tosola/BOX_rulesheet.png": "7636",
	"./landing-pages/tosola/CreativeBC-BCID-ArtsCouncil-lockup_rgb_rev.png": "f627",
	"./landing-pages/tosola/ICON_AGE_TOSOLA.png": "df93",
	"./landing-pages/tosola/ICON_CANADA.png": "de0c",
	"./landing-pages/tosola/ICON_CROSSMEDIA.png": "4fc3",
	"./landing-pages/tosola/ICON_NO-AI.png": "516b",
	"./landing-pages/tosola/STORY_app.png": "b175",
	"./landing-pages/tosola/STORY_cards.png": "18e4",
	"./landing-pages/tosola/STORY_comic.png": "8a8f",
	"./landing-pages/tosola/STORY_spirits.png": "d628",
	"./landing-pages/tosola/TOSOLA_app.webm": "2b01",
	"./landing-pages/tosola/TOSOLA_comic.webm": "4e52",
	"./landing-pages/tosola/TOSOLA_deduction.webm": "2e55",
	"./landing-pages/tosola/TOSOLA_hero.png": "4fca",
	"./landing-pages/tosola/TOSOLA_thumbnail.jpg": "29a8",
	"./landing-pages/tosola/TS_ICON_CHAPTERS.png": "22c6",
	"./landing-pages/tosola/TS_ICON_CLUES.png": "0297",
	"./landing-pages/tosola/TS_ICON_COMIC_AR.png": "e699",
	"./landing-pages/tosola/TS_ICON_CRITTERS.png": "6a97",
	"./landing-pages/tosola/TS_ICON_NATURE.png": "95ae",
	"./landing-pages/tosola/TS_ICON_SOLO.png": "23e5",
	"./logo-updated.png": "8642",
	"./logo_small.png": "717f",
	"./pattern-col-blue.png": "feca",
	"./pin_bear.png": "f706",
	"./player/play-large.png": "3714",
	"./player/sm-player-fullscreen-close.png": "5876",
	"./player/sm-player-fullscreen-open.png": "efe1",
	"./player/sm-player-pause.png": "c912",
	"./player/sm-player-play.png": "468e",
	"./player/sm-player-sound-loud.png": "1f11",
	"./player/sm-player-sound-medium-loud.png": "a201",
	"./player/sm-player-sound-mute.png": "3b4d",
	"./product/BEAR_HERO.png": "99f7",
	"./product/DANCINGSHADOWS_HERO.png": "657f",
	"./product/HIDDEN_HERO.png": "3689",
	"./product/RBS01/BEAR_SQUARE.jpg": "2976",
	"./product/RBS01/product-shot_01.jpg": "903b",
	"./product/RBS01/product-shot_01_loading.jpg": "73d4",
	"./product/RBS01/product-shot_02.jpg": "82bb",
	"./product/RBS01/product-shot_02_loading.jpg": "a2a3",
	"./product/RBS01/product-shot_03.jpg": "230f",
	"./product/RBS01/product-shot_03_loading.jpg": "b74b",
	"./product/RBS01/product-shot_04.jpg": "871b",
	"./product/RBS01/product-shot_04_loading.jpg": "4fd1",
	"./product/RBS01/product-shot_05.jpg": "931b",
	"./product/RBS01/product-shot_05_loading.jpg": "e84b",
	"./product/RBS01/product-shot_06.jpg": "17bb",
	"./product/RBS01/product-shot_06_loading.jpg": "8703",
	"./product/RBS01/product-shot_07.jpg": "4584",
	"./product/RBS01/product-shot_07_loading.jpg": "0eb4",
	"./product/RBS01/product-shot_08.jpg": "9d01",
	"./product/RBS01/product-shot_08_loading.jpg": "42b9",
	"./product/RBS01/product-shot_09.jpg": "9bd5",
	"./product/RBS01/product-shot_09_loading.jpg": "b5e1",
	"./product/RBS02/product-shot_01.jpg": "7179",
	"./product/RBS02/product-shot_01_loading.jpg": "b78e",
	"./product/RBS02/product-shot_02.jpg": "32dd",
	"./product/RBS02/product-shot_02_loading.jpg": "166e",
	"./product/RBS02/product-shot_03.jpg": "c383",
	"./product/RBS02/product-shot_03_loading.jpg": "837f",
	"./product/RBS02/product-shot_04.jpg": "14ec",
	"./product/RBS02/product-shot_04_loading.jpg": "d3ae",
	"./product/RBS02/product-shot_05.jpg": "8f04",
	"./product/RBS02/product-shot_05_loading.jpg": "9d8d",
	"./product/RBS02/product-shot_06.jpg": "719c",
	"./product/RBS02/product-shot_06_loading.jpg": "5922",
	"./product/RBS02/product-shot_07.jpg": "486a",
	"./product/RBS02/product-shot_07_loading.jpg": "5faf",
	"./product/RBS03a/S1E1_RetailVideo.mp4": "2a1f",
	"./product/RBS03a/product-shot_01.jpg": "b56b",
	"./product/RBS03a/product-shot_01_loading.jpg": "7b3d",
	"./product/RBS03a/product-shot_02.jpg": "a363",
	"./product/RBS03a/product-shot_02_loading.jpg": "7b08",
	"./product/RBS03a/product-shot_03.jpg": "5215",
	"./product/RBS03a/product-shot_03_loading.jpg": "a711",
	"./product/RBS03a/product-shot_04.jpg": "8e04",
	"./product/RBS03a/product-shot_04_loading.jpg": "4ddf",
	"./product/RBS03a/product-shot_05.jpg": "1abd",
	"./product/RBS03a/product-shot_05_loading.jpg": "0a3b",
	"./product/RBS03b/S1E2_RetailVideo.mp4": "74a1",
	"./product/RBS03b/product-shot_01.jpg": "a2aa",
	"./product/RBS03b/product-shot_01_loading.jpg": "fad7",
	"./product/RBS03b/product-shot_02.jpg": "6ef3",
	"./product/RBS03b/product-shot_02_loading.jpg": "95ac",
	"./product/RBS03b/product-shot_03.jpg": "3ae2",
	"./product/RBS03b/product-shot_03_loading.jpg": "ecba",
	"./product/RBS03b/product-shot_04.jpg": "e20b",
	"./product/RBS03b/product-shot_04_loading.jpg": "58a5",
	"./product/RBS03b/product-shot_05.jpg": "ddf2",
	"./product/RBS03b/product-shot_05_loading.jpg": "a84f",
	"./product/RBS03c/S2E1_RetailVideo.mp4": "59b8",
	"./product/RBS03c/product-shot_01.jpg": "b7aa",
	"./product/RBS03c/product-shot_01_loading.jpg": "4806",
	"./product/RBS03c/product-shot_02.jpg": "2fe6",
	"./product/RBS03c/product-shot_02_loading.jpg": "67c6",
	"./product/RBS03c/product-shot_03.jpg": "8fee",
	"./product/RBS03c/product-shot_03_loading.jpg": "c740",
	"./product/RBS03c/product-shot_04.jpg": "0532",
	"./product/RBS03c/product-shot_04_loading.jpg": "233a",
	"./product/RBS03c/product-shot_05.jpg": "2386",
	"./product/RBS03c/product-shot_05_loading.jpg": "7db9",
	"./product/RBS03c/product-shot_06.jpg": "9fa6",
	"./product/RBS03c/product-shot_06_loading.jpg": "11ed",
	"./product/RBS03d/S2E2_RetailVideo.mp4": "3141",
	"./product/RBS03d/product-shot_01.jpg": "1bc7",
	"./product/RBS03d/product-shot_01_loading.jpg": "7af5",
	"./product/RBS03d/product-shot_02.jpg": "1224",
	"./product/RBS03d/product-shot_02_loading.jpg": "9eaf",
	"./product/RBS03d/product-shot_03.jpg": "b436",
	"./product/RBS03d/product-shot_03_loading.jpg": "c083",
	"./product/RBS03d/product-shot_04.jpg": "9c9c",
	"./product/RBS03d/product-shot_04_loading.jpg": "38be",
	"./product/RBS03d/product-shot_05.jpg": "625c",
	"./product/RBS03d/product-shot_05_loading.jpg": "73ce",
	"./product/RBS03d/product-shot_06.jpg": "bf34",
	"./product/RBS03d/product-shot_06_loading.jpg": "93b0",
	"./product/RBS04/RBS04_1.jpg": "ccd7",
	"./product/RBS04/RBS04_1_loading.jpg": "f537",
	"./product/RBS04/RBS04_2.jpg": "7592",
	"./product/RBS04/RBS04_2_loading.jpg": "5f4a",
	"./product/RBS04/RBS04_3.jpg": "5dcc",
	"./product/RBS04/RBS04_3_loading.jpg": "03f6",
	"./product/RBS04/RBS04_4.jpg": "0359",
	"./product/RBS04/RBS04_4_loading.jpg": "af08",
	"./product/RBS04/RBS04_5.jpg": "f72a",
	"./product/RBS04/RBS04_5_loading.jpg": "0cde",
	"./product/RBS04/RBS04_6.jpg": "a527",
	"./product/RBS04/RBS04_6_loading.jpg": "3a92",
	"./product/RBS04/RBS04_7.jpg": "cd10",
	"./product/RBS04/RBS04_7_loading.jpg": "565d",
	"./product/RBS04/RBS04_thumb.jpg": "f346",
	"./product/RBS04/RBS04_thumb_loading.jpg": "59d8",
	"./product/TOSOLA_HERO.png": "fd3b",
	"./sm_ig.png": "4d75",
	"./sm_tiktok.png": "5a2e",
	"./sm_yt.png": "e77c",
	"./tag_best-seller.png": "3b3c",
	"./tag_coming-soon.png": "0f25",
	"./tag_new-release.png": "fbe1",
	"./text_interactive-story-puzzle_white.png": "f9cd",
	"./the-bear-chapters_app-icon.png": "48c1",
	"./title_white.png": "1797",
	"./tosola_app-icon.png": "c123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";